module.exports = __webpack_public_path__ + "static/img/boxLogin.d950880.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/boxLogin.png
// module id = d3VN
// module chunks = 3